module.exports = __webpack_public_path__ + "assets/img/e8ddfe7f92a0fc5fa449e8ddb1aef2ca.svg";